import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'

import FormControl from './FormControl'

export default class UploadAvatar extends FormControl {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
    disabled: PropTypes.bool,
    initialValue: PropTypes.string,
    validationFuncs: PropTypes.array,
    onFileChange: PropTypes.func,
    initialPhoto: PropTypes.string,
    helpTextClassName: PropTypes.string,
    customDiv: PropTypes.array,
    customClassWrapper: PropTypes.string
  }

  static defaultProps = {
    disabled: false,
    validationFuncs: [],
    initialValue: ''
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.initialValue !== nextProps.initialValue) {
      if (typeof this.props.onChange !== 'undefined') {
        this.props.onChange(this.props.id, nextProps.initialValue)
      }

      this.setState({
        fileName: nextProps.initialValue
      })
    }

    if (nextProps.revalidate) {
      this.validate()
    }
  }

  handleChange = e => {
    this.props.onFileChange(e)
  }

  getChangeValue() {
    return this.state.value
  }

  getValue() {
    return this.state.value
  }

  onFileSelect = e => {
    e.persist()

    let file = e.target.files[0]
    let fileReader = new FileReader()
    fileReader.onload = event =>
      this.setState({
        value: {
          size: file.size,
          name: file.name,
          type: file.type,
          fileDataUrl: event.target.result,
          fileBlob: file.preview,
          file
        }
      })
    fileReader.readAsDataURL(file)
    setTimeout(() => {
      this.handleChange(e)
      this.validate()
    }, 250)
  }

  render() {
    const {
      id,
      label,
      labelClass,
      placeholder,
      disabled,
      helpText,
      initialPhoto,
      helpTextClassName,
      customDiv,
      customClassWrapper,
      format
    } = this.props
    const groupClass = classNames({
      'form-group': !this.props.isGroup ? this.props.isGroup : true,
      'has-danger': !this.state.isValid
    })

    return (
      <fieldset className={customClassWrapper || groupClass} id={id}>
        <input
          type="file"
          accept={format}
          id="file"
          name="file"
          placeholder={placeholder}
          className="profile__hiddeninput"
          onChange={this.onFileSelect}
          disabled={disabled}
        />
        {!!initialPhoto ? (
          <div className="profile_div">
            <label htmlFor="file" className="profile_avatar">
              <img src={initialPhoto} alt="avatar" />
            </label>
          </div>
        ) : customDiv ? (
          customDiv
        ) : (
          <div className="profile_div">
            <label htmlFor="file" className="profile_fa">
              <i className="fa fa-plus-circle fa-2x " aria-hidden="true">
                {' '}
              </i>
            </label>
          </div>
        )}
        {helpText && <small className={helpTextClassName ? this.props.helpTextClassName : 'text-muted'}>{helpText}</small>}
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/UploadAvatar.js